import { InjectionToken } from '@angular/core';

export class BaseUriConfig {
    constructor(public readonly apiUri: string) {}
}

export const BASE_URI_CONFIG = new InjectionToken<BaseUriConfig>('BASE_URI_CONFIG');
